module.exports = __webpack_public_path__ + "static/favicon-84d07fafaa4a001b0de743070ea817a0.ico";